<template>
  <span>
    <v-container class="my-0">
      <v-row no-gutters class="pa-0 fill-height">
        <!--FooterNewsLetterTitle -->
        <v-col
          v-if="siteSettings.FooterNewsLetterTitle.length < 19"
          cols="auto"
          sm="5"
          md="auto"
          :style="{ height: '70px' }"
        >
          <v-sheet class="fill-height pa-0">
            <v-container class="fill-height py-0 d-flex flex-row-reverse">
              {{ siteSettings.FooterNewsLetterTitle }}</v-container
            >
          </v-sheet>
        </v-col>
        <v-col
          v-if="siteSettings.FooterNewsLetterTitle.length > 18"
          cols="4"
          sm="5"
          md="auto"
          :style="{ height: '70px' }"
        >
          <v-sheet class="fill-height pa-0">
            <v-container
              class="fill-height py-0 bg-gree d-flex flex-row-reverse"
            >
              {{ siteSettings.FooterNewsLetterTitle }}</v-container
            >
          </v-sheet>
        </v-col>
        <!--/-->
        <v-col :style="{ height: '70px' }">
          <v-sheet class="fill-height pa-0">
            <v-container class="fill-height pa-0">
              <v-text-field
                :loading="loading"
                density="compact"
                variant="solo"
                class="bg-contrast"
                :label="siteSettings.FooterNewsLetterEmail"
                append-inner-icon="mdi-magnify"
                single-line
                v-model="email"
                hide-details
              
              ></v-text-field>
            </v-container>
          </v-sheet>
        </v-col>
        <v-col :style="{ height: '70px' }" cols="auto">
          <v-sheet class="fill-height pa-0">
            <v-container class="fill-height py-0">
              <v-btn
                @click="signupnieuwsLetter()"
                variant="outlined"
                block
                height="42px"
                class="px-2 my-0 text-none newsletterbar"
                width="100%"
              >
                Bevestig
              </v-btn></v-container
            >
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </span>
</template>
<script setup>
const dataAll = useDataAll();
const siteSettings = useSiteSettingsStore();
const pageOverviewStore = usePageOverviewStore()
const { $helpers, $methods } = useNuxtApp()
let loading = false;
let responseMessage = "";
let email = ref("");
let alertType = "error";
// function isEmailValid() {
//   return email.value == "" ? "" : reg.test(email.value) ? true : false;
// }
async function signupnieuwsLetter() {
  alertType = "success";
  responseMessage = "";
  const newsLetterPage = pageOverviewStore.getPageByType("NA")

  if ($helpers.isset(newsLetterPage?.Code)){
    navigateTo({
      path: $methods.localePath(newsLetterPage.Code),
      query: { Email: email.value },
    });
    email.value = ''
  } else {
    alert('No newsletter page found, use the contact page')
  }
}

const getAlign = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return "left";
    case "sm":
      return "right";
    case "md":
      return "right";
    case "lg":
      return "right";
    case "xl":
      return "right";
    case "xxl":
      return "right";      
    default:
      return "right";
  }
});
</script>
